import { withInstall } from '@tav-ui/utils/with-install'
import Loading from './src/loading.vue'
export const TaLoading = withInstall(Loading)
export default TaLoading
export { createLoading } from './src/createLoading'
export * from './src/types'
export { useLoading } from './src/useLoading'
